import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';

import { useFragment } from '@libs/trip-planner-interfaces';
import type {
  FragmentType,
  GraphQL,
  TransportLeg,
  TransportSegment,
} from '@libs/trip-planner-interfaces';

import { LegFragment } from '../../queries';
import { assertSmartSearchList, assertSmartSearchValue } from '../../utils';

type LegFragmentQL = FragmentType<
  DocumentTypeDecoration<GraphQL.LegFragment, unknown>
>;
export function toLeg(legFragmentQL: LegFragmentQL): TransportLeg {
  const legFragment = useFragment(LegFragment, legFragmentQL);

  assertSmartSearchList(legFragment.segments);

  return {
    durationInMinutes: legFragment.durationInMinutes,
    segments: legFragment.segments.map(toSegment),
  };
}

type SegmentsQL = NonNullable<GraphQL.LegFragment['segments']>;
type SegmentQL = NonNullable<SegmentsQL[number]>;
function toSegment(segmentQL: SegmentQL): TransportSegment {
  assertSmartSearchValue(segmentQL.layoverTimeUntilNextSegmentInMinutes);
  assertSmartSearchValue(segmentQL.transportType);

  return {
    arrivalDateTime: new Date(segmentQL.arrivalDateTime),
    arrivalIata: segmentQL.arrivalIata,
    carrier: segmentQL.carrier,
    departureDateTime: new Date(segmentQL.departureDateTime),
    departureIata: segmentQL.departureIata,
    isCabinMandatory: segmentQL.isCabinMandatory,
    layoverTimeUntilNextSegmentInMinutes:
      segmentQL.layoverTimeUntilNextSegmentInMinutes,
    operatingCarrier: segmentQL.operatingCarrier,
    transportId: segmentQL.transportId,
    transportType: segmentQL.transportType,
    durationInMinutes: segmentQL.durationInMinutes,
    transportationName: segmentQL.transportationName ?? undefined,
    vehicles: segmentQL.vehicles?.map((vehicle) => {
      assertSmartSearchValue(vehicle);
      return vehicle;
    }),
  };
}
